// extracted by mini-css-extract-plugin
export var creditCardIntro = "CreditCardIntro-module--creditCardIntro--a7208";
export var cta = "CreditCardIntro-module--cta--a6c77";
export var legalText = "CreditCardIntro-module--legalText--55791";
export var lgBreak = "1200";
export var mdBreak = "992";
export var representativeExample = "CreditCardIntro-module--representativeExample--01f09";
export var smBreak = "768";
export var xsBreak = "480";